import React from 'react';
import { Link } from 'react-router-dom';
import { FindLocation } from '../CustomHooks';
import { MainBtn, SecondaryBtn } from '../Styled';
import { CtaCon, CtaLeft, CtaPara, CtaTitle, Mockups, UpperCta } from './CTAUp.styles';



const CTAUp = ({ title, body, btn, photo, alt, to }) => {
  const location = FindLocation();
  return (
    <UpperCta>
      <CtaLeft>
        <CtaTitle className={location.pathname === '/webudvikling' ? 'white' : ''}>
          {title}
        </CtaTitle>
        <CtaPara className={location.pathname === '/webudvikling' ? 'white' : ''}>
          {body}
        </CtaPara>
        {
          btn !== null ? (
            <Link to={to}>
              {
                location.pathname === '/webudvikling' ? (
                  <MainBtn>{btn}</MainBtn>
                ) : (
                  <SecondaryBtn>{btn}</SecondaryBtn>
                )
              }
            </Link>
          ) : null
        }
      </CtaLeft>
      <CtaCon>
        <Mockups src={photo} alt={alt} />
      </CtaCon>
    </UpperCta>
  );
};

export default CTAUp;
